export default __webpack_public_path__ + "static/media/loyalty.ea787f81.png";